export const notificationTypes = {
  TEST: 'TestPushNotification',
  GAME_FINISHED: 'GameFinishedNotification',
  LIVE_STREAM: 'GameLiveStreamNotification',
  INVITATION: 'InvitationNotification',
  ATTENDANCE: 'PlayerAttendanceNotification',
  UPCOMING_GAME: 'UpcomingGameNotification',
  PLAYER_SUSPENDED: 'PlayerSuspendedNotification',
  PLAYER_SUSPENDED_COMPLETED: 'PlayerSuspendedCompletedNotification',
  GAME_SCORED_NOTIFICATION: 'GoalScoredNotification',
  GAME_STATUS_UPDATE: 'GameStatusUpdateNotification',
  GAME_RESCHEDULED_UPDATE: 'GameRescheduledUpdateNotification',
  SOCIAL_FEED: 'SocialFeedNotification',
  OFFENSE: 'OffenseNotification',
  PERIOD: 'PeriodNotification',
  GAME_ROSTER_ROLE_ASSIGNED: 'GameRosterRoleAssignedNotification',
  REGISTRATION_PAYMENT: 'RegistrationPaymentNotification',
  // SN-4709 D39 — the actionable "an offline payment needs your verification"
  // notice. Values are the backend notification class names.
  OFFLINE_PAYMENT_PENDING_VERIFICATION:
    'OfflinePaymentPendingVerificationNotification',
  // Deliberately NOT actionable: it only confirms the recorder's own entry landed.
  OFFLINE_PAYMENT_RECORDED_CONFIRMATION:
    'OfflinePaymentRecordedConfirmationNotification',
  SPARE_AVAILABILITY_REQUEST: 'SpareAvailabilityRequestNotification',
  // SN-8340 — the two Team-Managed Budget money notices. Both are ACTIONABLE: they
  // carry an `action_url` to the player's payable bill. Without an entry here
  // NotificationItem's `isRecognizedType` was false and clicking them did nothing.
  // Web-only so far: mobile's navigation is a separate switch with its own default,
  // so adding these keys is additive there and changes nothing.
  BALANCE_ALLOCATION: 'BalanceAllocationNotification',
  BALANCE_PAYMENT_REMINDER: 'BalancePaymentReminderNotification',
}
